/**
 * 引导绑定手机号码
 */
import Confirm from '../../lib/popup/confirm';
import bindPhonePop from '../withdraw/bindphone-pop';
import lang from '../../lang';

export default {
	show: function() {
		UP.Global.DA.add({
            eventName: 'clickBindPhoneBtnAfterRecharge',
            action: 'click'
        });

		Confirm.create({
			content: lang.template('为保证您的账户和财产安全，请绑定手机号'),
			onConfirm: function() {
				bindPhonePop.create({
				 	onComplete: function(){
				 		UP.Global.DA.add({
				            eventName: 'bindPhoneSuccessAfterRecharge',
				            action: 'click'
				        });
				 	}
				});
			}
		});
	}	
}


// WEBPACK FOOTER //
// ./js/mall/bindphone-guid/index.js